import * as ProfileApiService from '../services/api/requests/Profile'
import * as RegisterApiService from '../services/api/requests/Register' // move to registeration controller

import convertDataURIToBlob from '../services/binaries/convertDataURIToBlob'

import { MAIN } from '../services/data/profilePages.json'
import { STEP_DEFAULT } from '../services/data/uploadAvatarSteps.json'
import { encodeSSOData, saveSSOData } from '../services/data/sso'

const STEP_UPDATE_FORM = null

// update missing data
export const doUpdateMissingData = ({
  accessToken,
  setPrimaryInfo,
  primaryInfo,
  callback,
}) => async (values, state) => {
  state.setSubmitting(true)
  const details = {
    birthdate: values.birthdate,
    gender: values.gender,
  }
  try {
    const profileResponse = await ProfileApiService.postMissingDetails(
      accessToken,
      details,
    )

    const updatedInfo = profileResponse.data

    setPrimaryInfo({ ...primaryInfo, ...updatedInfo })

    callback && callback()
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }

  state.setSubmitting(false)
}

// get user  settings
export const doGetUserSettings = ({
  accessToken,
  setUserSettings,
}) => async () => {
  try {
    //   const {receiveAnnouncement}  = await getUserSettings(accessToken)
    if (accessToken) {
      await ProfileApiService.getUserSettings(accessToken)
        .then(response => {
          const { data } = response
          setUserSettings(data)
        })
        .catch(() => {
          setUserSettings(null)
        })
    }
  } catch (error) {}
}

// update user settings
export const doSetUserSettings = ({
  accessToken,
  setUserSettings,
  userSettings,
  setDisable,
  toggleSettingsModal,
  displayModal,
}) => async () => {
  setDisable(true)
  try {
    if (accessToken)
      await ProfileApiService.postUserSettings(accessToken, userSettings)
        .then(response => {
          const { data } = response
          setUserSettings(data)
          toggleSettingsModal && displayModal && toggleSettingsModal()
        })
        .catch(() => {
          setUserSettings(null)
        })
  } catch (error) {}
  setDisable(false)
}

// update profile
export const doUpdateProfile = ({
  accessToken,
  primaryInfo,
  setAccessToken,
  setPrimaryInfo,
  setProfileModalPage,
  updateStateCallback,
}) => async (values, state) => {
  const { mobileNumber: oldMobileNumber } = primaryInfo || {}

  state.setSubmitting(true)
  try {
    const validateResponse = await ProfileApiService.updateProfile(
      values,
      accessToken,
    )

    const { status: responseStatus, data: responseData } = validateResponse

    if (responseStatus === 200) {
      const {
        accessToken: newAccessToken,
        expiresIn,
        refreshToken,
        refreshExpiresIn,
        user,
        // code,
      } = validateResponse.data
      const token = encodeSSOData({
        accessToken: newAccessToken,
        expiresIn,
        refreshToken,
        refreshExpiresIn,
        // code,
      })

      // sso
      setAccessToken(newAccessToken)
      saveSSOData(token)

      // profile
      setPrimaryInfo(user)

      setProfileModalPage(MAIN)
    } else if (responseStatus === 202) {
      const { mobileNumber } = values
      const { updateProfileStep, updateProfileToken } = responseData

      state.setFieldValue('mobileNumber', oldMobileNumber)

      updateStateCallback &&
        updateStateCallback({
          newMobileNumber: mobileNumber,
          updateProfileStep,
          updateProfileToken,
          resendData: values,
        })
    }
  } catch (error) {
    const { data = {} } = error.response || {}
    // const { message = 'Network Error' } = data || {}
    const { message } = data || {}

    state.setStatus({
      error: message || 'There was an error processing your request',
    })

    if (
      typeof message === 'object' &&
      message[0].toLowerCase().indexOf('first name') >= 0
    ) {
      state.setFieldError('firstName', message)
      state.setStatus({})
    }
    if (
      typeof message === 'object' &&
      message[0].toLowerCase().indexOf('last name') >= 0
    ) {
      state.setFieldError('lastName', message)
      state.setStatus({})
    }
    if (
      typeof message === 'string' &&
      message.toLowerCase().indexOf('email') >= 0
    ) {
      state.setFieldError('email', message)
      state.setStatus({})
    }
    if (
      typeof message === 'string' &&
      message.toLowerCase().indexOf('mobile') >= 0
    ) {
      state.setFieldError('mobileNumber', message)
      state.setStatus({})
    }
  }
  state.setSubmitting(false)
}

// post avatar image
export const doSubmitAvatar = ({
  accessToken,
  setPrimaryInfo,
  setAvatarState,
  changePage,
}) => async (values, state) => {
  state.setSubmitting(true)

  const { displayPhoto } = values

  try {
    await RegisterApiService.postAvatar(
      { image: convertDataURIToBlob(displayPhoto) },
      { accessToken },
    )

    if (setPrimaryInfo) {
      const { data } = await ProfileApiService.getUserAvatar(accessToken)
      const urlCreator = window.URL || window.webkitURL
      const avatarUrl = urlCreator.createObjectURL(data)
      if (setPrimaryInfo) {
        await setPrimaryInfo({ avatarUrl })
      }
    }

    setAvatarState(STEP_DEFAULT)
    changePage(STEP_UPDATE_FORM)
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }
  state.setSubmitting(false)
}

// resend otp for update profile
export const doResendOTPUpdateProfile = ({ updateProfileToken }) => async (
  values,
  state,
) => {
  state.setSubmitting(true)

  try {
    await ProfileApiService.postUpdateProfileOtpResend(updateProfileToken)
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }
  state.setSubmitting(false)
}

// verify otp for update profile
export const doVerifyOTPUpdateProfile = ({
  accessToken,
  setAccessToken,
  setPrimaryInfo,
  setProfileModalPage,
  updateProfileToken,
  saveAccessToken,
}) => async (values, state) => {
  const { code } = values

  state.setSubmitting(true)

  // REMOVED - validateProfileOtp function no longer exists
  try {
    // const validateResponse = await ProfileApiService.validateProfileOtp(
    //   code,
    //   updateProfileToken,
    //   accessToken,
    // )
    const validateResponse = { data: null }

    const {
      accessToken: newAccessToken,
      expiresIn,
      refreshToken,
      refreshExpiresIn,
      user,
    } = validateResponse.data
    const token = encodeSSOData({
      accessToken: newAccessToken,
      expiresIn,
      refreshToken,
      refreshExpiresIn,
    })

    // sso
    setAccessToken(newAccessToken)
    saveAccessToken(newAccessToken)
    saveSSOData(token)

    // profile
    setPrimaryInfo(user)

    setProfileModalPage(MAIN)
  } catch (error) {
    const { data = {} } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      error: 'There was an error processing your request',
    })

    if (message.toLowerCase().indexOf('otp') >= 0) {
      state.setFieldError('code', 'Invalid OTP')
      state.setStatus({})
    }
  }
  state.setSubmitting(false)
}

// post avatar image
export const doPostAvatar = ({
  accessToken,
  setPrimaryInfo,
  setProfileModalPage,
}) => async (values, state) => {
  state.setSubmitting(true)

  const { displayPhoto } = values

  try {
    const response = await RegisterApiService.postAvatar(
      { image: convertDataURIToBlob(displayPhoto) },
      { accessToken },
    )

    if (setPrimaryInfo) {
      const { data } = await ProfileApiService.getUserAvatar(accessToken)
      const urlCreator = window.URL || window.webkitURL
      const avatarUrl = urlCreator.createObjectURL(data)
      if (setPrimaryInfo) {
        setPrimaryInfo({
          ...response.data,
          avatarUrl,
        })
      }
    }

    if (setProfileModalPage) setProfileModalPage(MAIN)
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }
  state.setSubmitting(false)
}

// get favorite malls
export const doGetFavoriteMalls = async ({ accessToken, setFavoriteMalls }) => {
  if (accessToken) {
    await ProfileApiService.getAllFavoriteMalls(accessToken).then(response => {
      setFavoriteMalls(response.data)
    })
  }
}

// set favorite malls
export const doSetFavoriteMalls = ({
  accessToken,
  onSuccess = () => {},
  onError = () => {},
  callback = () => {},
}) => async id => {
  try {
    await ProfileApiService.postFavoriteMall(id, accessToken)
    onSuccess()
  } catch (error) {
    onError(error)
  }
  callback()
}

// get account status
export const doGetAccountStatus = async ({
  accessToken,
  setAccountStatus,
  onSuccess = () => {},
  onError = () => {},
}) => {
  if (accessToken) {
    try {
      const response = await ProfileApiService.getAccountStatus(accessToken)
      setAccountStatus(response.data)
      onSuccess(response)
    } catch (error) {
      onError(error)
      setAccountStatus(null)
    }
  }
}

// email verification
export const doVerifyEmail = async ({
  accessToken,
  setEmailVerificationStatus = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  try {
    const response = await ProfileApiService.postEmailVerification(
      accessToken,
    ).then(async () => {
      const verificationResponse = await ProfileApiService.getEmailVerification(
        accessToken,
      )
      return verificationResponse
    })
    const { status } = response.data || {}
    setEmailVerificationStatus(status)
    onSuccess(response)
  } catch (error) {
    onError(error)
  }
}

// email verification
export const doGetEmailVerificationStatus = async ({
  accessToken,
  setEmailVerificationStatus = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  if (accessToken) {
    try {
      const response = await ProfileApiService.getEmailVerification(accessToken)
      const { status } = response.data || {}
      setEmailVerificationStatus(status)
      onSuccess(response)
    } catch (error) {
      setEmailVerificationStatus(0)
      onError(error)
    }
  }
}
// export const doGetLoungePass = async ({
//   accessToken,
//   onSuccess = () => {},
//   onError = () => {},
// }) => {
//   try {
//     const response = await ProfileApiService.getLoungePass(accessToken)
//     onSuccess(response.data)
//   } catch (error) {
//     onError(error)
//   }
// }
// claim lounge pass
export const doClaimLoungePass = async ({
  accessToken,
  setAccountStatus = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => {
  try {
    const response = await ProfileApiService.postLoungePass(accessToken)
    // setAccountStatus(response.data)
    onSuccess(response.data)
  } catch (error) {
    onError(error)
  }
}
